import valid from 'card-validator';

import { isValid as isValidCpf } from '@fnando/cpf';

$.validaty

  .register('cpf', 'CPF inválido!', function (_helper, _el) {
    'use strict';

    return this.val() === '' || isValidCpf(this.val());
  })

  .register('email', 'Esse e-mail não parece válido', function (_helper, _el) {
    'use strict';

    const value = this.val().trim();

    return value === '' || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  })

  .register('file', 'Selecione um arquivo', function () {
    'use strict';

    return this[0].files.length > 0;
  })

  .register(
    'required',
    {
      checkbox: 'Faltou selecionar aqui',
      email: 'Faltou preencher aqui',
      number: 'Faltou preencher aqui',
      radio: 'Faltou selecionar aqui',
      select: 'Faltou escolher aqui',
      tel: 'Faltou preencher aqui',
      text: 'Faltou preencher aqui',
      textarea: 'Faltou preencher aqui',
    },
    function (helper, el) {
      'use strict';

      if (helper.isCheckable(this[0])) {
        const attributes = '[name="' + this.attr('name') + '"]:checked';

        return $(el).find(':radio' + attributes + ', :checkbox' + attributes).length > 0;
      } else {
        return this.val().trim() !== '';
      }
    },
  )

  .register('credit-card-number', 'Número inválido!', function (_helper, _el) {
    'use strict';

    const value = this[0].value.trim();

    return valid.number(value).isValid;
  })

  .register('credit-card-cvv', 'CVV inválido!', function (_helper, el) {
    ('use strict');

    const cardNumber = el[0].querySelector('[data-card-number-field]');

    const cardValidation = valid.number(cardNumber?.value);
    const maxLength = cardValidation.card?.type === 'american-express' ? 4 : 3;

    const value = this[0].value.trim();

    return valid.cvv(value, maxLength).isValid;
  })

  .register('credit-card-expiration', 'Use mês/ano (mm/aa)!', function (_helper, _el) {
    'use strict';

    const value = this[0].value.trim();

    return valid.expirationDate(value).isValid;
  })

  .register('credit-card-expiration-month', 'Use mês (mm)!', function (_helper, _el) {
    'use strict';

    const value = this[0].value.trim();

    return valid.expirationMonth(value).isValid;
  })

  .register('credit-card-expiration-year', 'Use ano (aa)!', function (_helper, _el) {
    'use strict';

    const value = this[0].value.trim();

    return valid.expirationYear(value).isValid;
  })

  .register('min_checked', { checkbox: 'Faltou selecionar aqui' }, function (_helper, el) {
    'use strict';

    const attributes = `[data-group="${this[0].dataset.group}"]:checked`;

    return $(el).find(':checkbox' + attributes).length > 0;
  });
